import React, { useContext, useState } from 'react'
import { EngagementLetterContext } from './EngagementLetter'
import { GlobalContext } from '../../../../App'
import { Button, IconButton, Stack, TextField, Typography } from '@mui/material'
import Delete from '@mui/icons-material/Delete'
import API from '../../../../services/API'

const ClientObligations = () => {
  const { engagementLetter, setEngagementLetter } = useContext(
    EngagementLetterContext
  )
  const [newClientObligation, setNewClientObligation] = useState('')
  const { setToast } = useContext(GlobalContext)

  const handleSubmitNew = (e) => {
    e.preventDefault()
    API.put('/site-config', {
      'wordings.engagementLetter.clientObligations': [
        ...engagementLetter.clientObligations,
        newClientObligation,
      ],
    })
      .then((res) => {
        if (res.status === 200) {
          setToast({
            message: 'Engagement Letter Updated',
          })
          setNewClientObligation('')
          setEngagementLetter((prev) => ({
            ...prev,
            clientObligations: [...prev.clientObligations, newClientObligation],
          }))
        }
      })
      .catch(() => {
        setToast({
          message: 'Unable to Update. Please try again later.',
          severity: 'error',
        })
      })
  }

  const handleDelete = (index) => {
    const newArray = [...engagementLetter.clientObligations]
    newArray.splice(index, 1)
    API.put('/site-config', {
      'wordings.engagementLetter.clientObligations': newArray,
    })
      .then((res) => {
        if (res.status === 200) {
          setToast({ message: 'Engagement Letter Updated' })
          setEngagementLetter((prev) => ({
            ...prev,
            clientObligations: newArray,
          }))
        }
      })
      .catch(() =>
        setToast({
          message: 'Unable to Update. Please try again later.',
          severity: 'error',
        })
      )
  }

  return (
    <Stack>
      <Typography variant="title3">Client Obligations</Typography>
      <Typography variant="caption">The Client will...</Typography>
      <ul>
        {engagementLetter.clientObligations.map((x, i) => (
          <li key={i}>
            <Stack
              direction="row"
              justifyContent="space-between"
              alignItems="center"
              gap={0.5}
            >
              <Typography>{x}</Typography>
              <Button>
                <Delete color="error" onClick={() => handleDelete(i)} />
              </Button>
            </Stack>
          </li>
        ))}
      </ul>
      <Stack
        direction={{ xs: 'column', lg: 'row' }}
        gap={1}
        component="form"
        onSubmit={handleSubmitNew}
      >
        <TextField
          value={newClientObligation}
          onChange={(e) => setNewClientObligation(e.target.value)}
          fullWidth
          label="Add a new Client Obligation"
          autoComplete="off"
          required
        />
        <Button
          disabled={!newClientObligation}
          variant="contained"
          color="success"
          type="submit"
        >
          Submit
        </Button>
      </Stack>
    </Stack>
  )
}

export default ClientObligations
